<h1 class="u-sr-only">{{ 'Booking.Title.Book' | translate }}</h1>
<div *ngIf="!vm.isSiffi" class="o-grid o-grid--wrap">
	<div class="o-grid__cell o-grid__cell--w-100 u-hidden@up-to-md">
		<h2 class="c-text c-text--heading c-text--xl u-osb-lg u-hidden@up-to-md">
			{{vm.title}}
		</h2>
	</div>
</div>
<div class="o-grid o-grid--center-h o-grid--wrap">
	<div class="o-grid__cell o-grid__cell--w-100 u-no-p@up-to-md">
		<h2 *ngIf="vm.isSiffi" class="c-text c-text--heading c-text--xl u-osb-lg u-hidden@up-to-md">
			{{vm.title}}
		</h2>
		<section class="c-section c-section--open">
			<div *ngIf="vm.isOutOfHoursMode" class="c-section__header">
				<h1 class="c-section__title c-section__title--sm c-text c-text--center@md-and-up">
					{{ ('Concierge.Welcome' | translate) + (!!vm.user['parentBusinessUser']['businessName'] ? ('Concierge.Valued_Employee' | translate) + ' ' + vm.user['parentBusinessUser']['businessName'] : '') }}
				</h1>
			</div>
			<div *ngIf="vm.isOutOfHoursMode" class="c-section__header" style="padding-bottom: 24px">
				<p style="text-align: center;" class="c-text c-text--wrap">{{ 'Concierge.Keywords_Info' | translate }}</p>
			</div>
			<div class="c-section__content">
				<form name="vm.form" #mainForm="ngForm" class="c-form">
					<div class="c-card">
						<div class="c-content c-content--xxl" *ngIf="vm.isInitialized">
							<div class="o-grid o-grid--center-h">
								<div class="o-grid__cell o-grid__cell--w-100 o-grid__cell--w-80@md-and-up u-no-p" [ngSwitch]="vm.showConsultantForm">
									<div *ngSwitchCase="true">
										<div class="c-form__group u-osb-sm u-osb-md" *ngIf="!vm.isOutOfHoursMode">
											<label for="languagePicker" class="c-form__label c-form__label c-form__label--light">
													{{ ('Booking.Instant.SelectPreferredLanguage.' + (vm.isSiffi ? 'Siffi' : 'Minudoc')) | translate }}
											</label>
											<input-autocomplete id="languagePicker"
											 	[ngClass]="{'c-form__group--error': vm.submitted && vm.noPrimaryLanguage}"
												name="countryCode"
												[(model)]="vm.primaryLanguage"
												[opts]="vm.languages"
												[searchFn]="vm.handleLanguageSearch"
												[selectFn]="vm.handleLanguageSelect"
												[clearFn]="vm.clearLanguageSearch"
												[isRequired]="true"
												[minLength]="2"
												[isSmall]="true">
											</input-autocomplete>
										</div>
										<div class="c-form__group u-no-m">
											<label for="problem" class="c-form__label c-form__label--light">
												{{ 'Booking.Instant.SelectOneOrMultipleOptions' | translate }}
											</label>
											<div class="c-tags__wrapper" [ngClass]="{'c-form__group--error': vm.submitted && vm.nothingSelected}">
												<div *ngFor="let answer of vm.answers ; let $index=index"
													 [ngClass]="{'c-tag--selected': answer.isSelected}"
													 (click)="vm.onAnswerClick($event, answer)"
													 style="display: table-cell; height: auto"
													 class="c-tag">
													<span id="answerLabel{{$index}}">{{answer.text}}</span>
												</div>
											</div>
											<div *ngIf="vm.isInputTextAreaShown" [ngClass]="{'c-form__group--error': vm.submitted && otherProblem.invalid}">
												<label for="problem" class="c-form__label c-form__label--light">{{ 'Booking.Instant.Mental_Problem' | translate }}</label>
												<textarea name="problem" id="problem" rows="6" class="c-form__input c-form__input" [(ngModel)]="vm.problem" #otherProblem="ngModel" required maxlength="{{vm.problemMaxLength}}"></textarea>
												<p class="c-text c-text--sm {{vm.textColor}} c-text--right">{{ otherProblem?.value?.length || 0 }} / {{ vm.problemMaxLength }}</p>
												<item-form-error *ngIf="vm.submitted && otherProblem.invalid" [fieldName]="'Booking.Problem_Description_Short' | translate" [error]="otherProblem.errors" style="margin-top: -10px"></item-form-error>
											</div>
										</div>
									</div>
									<div *ngSwitchDefault>
										<p class="c-text u-osb-xl">{{ 'Booking.Instant.Mental_Intro' | translate }}</p>
										<ul class="c-list c-list--unstyled">
											<li>
												<div id="chatWithConsultantElement" (click)="vm.toggleConsultantForm()" class="o-grid o-grid--center-v c-content c-content--border-bottom u-no-ph c-text c-text--s6 u-clickable">
													<div class="o-grid__cell u-no-pl">
														<p class="c-text u-osb-sm">{{ 'Booking.Instant.Mental_Consultant_Title' | translate }}</p>
														<p class="c-text {{vm.textColor}} c-text--sm">{{ 'Booking.Instant.Mental_Consultant_Description' | translate }}</p>
													</div>
													<div class="o-grid__cell u-no-pr o-grid__cell--w-fixed">
														<i class="o-icon o-icon--angle-r" aria-hidden="true"></i>
													</div>
												</div>
											</li>
											<li>
												<div id="followUpElement" (click)="vm.goToFollowUpHistory()" class="o-grid o-grid--center-v c-content u-no-ph c-text c-text--s6 u-clickable">
													<div class="o-grid__cell u-no-pl">
														<p class="c-text u-osb-sm">{{ 'Booking.Instant.Mental_Follow_Up_Title' | translate }}</p>
														<p class="c-text {{vm.textColor}} c-text--sm">{{ 'Booking.Instant.Mental_Follow_Up_Description' | translate }}</p>
													</div>
													<div class="o-grid__cell u-no-pr o-grid__cell--w-fixed">
														<i class="o-icon o-icon--angle-r" aria-hidden="true"></i>
													</div>
												</div>
											</li>
										</ul>
									</div>
								</div>
							</div>
						</div>
						<loader-overlay *ngIf="vm.isProcessing || !vm.isInitialized"></loader-overlay>
					</div>
					<div class="c-content u-no-pb u-no-ph@md-and-up" *ngIf="vm.isInitialized">
						<div class="o-grid">
							<div class="o-grid__cell u-hidden@up-to-md"></div>
							<div class="o-grid__cell o-grid__cell--w-100 o-grid__cell--w-fixed@md-and-up o-grid__cell--right u-no-p">
								<button id="formSubmitButton" type="button" class="c-button c-button--s2 c-button--fit c-button--lg" (click)="vm.handleFormSubmit(mainForm)" *ngIf="vm.showConsultantForm" [disabled]="vm.isProcessing">{{ 'Common.Next' | translate }}</button>
							</div>
						</div>
					</div>
				</form>
			</div>
		</section>
	</div>
</div>
